import { useMutation } from 'react-query';
import { useTranslation } from 'react-i18next';
import { dataFetch, DIGGER_API_SUFFIX } from '../../../axios/customAxios';
import { handleApiError } from '../../requestHelpers/requestHelpers';
import { ApiError, ApiResponse } from '../../../interfaces/apiResponse.type';
import closableEnqueueSnackbar from '../../../components/closableEnqueueSnackbar/closableEnqueueSnackbar';
import { useOrganizationSettingsStore } from '../../../store/organizationSettingsStore';

export const useSendRequestManager = () => {
  const { t } = useTranslation();
  const { organizationSettings, setOrganizationSettings } = useOrganizationSettingsStore();

  return useMutation<ApiResponse<null>, ApiError<null>>(
    () => dataFetch.post(
      `${DIGGER_API_SUFFIX}organizations/manager-request`,
    ),
    {
      onSuccess: () => {
        closableEnqueueSnackbar(t('requestToBeManagerSent'), 'success');
        setOrganizationSettings({ ...organizationSettings, managerialStatus: 1 });
      },
      onError: (error: any) => {
        handleApiError(error, t);
      },
    },
  );
};
